/**
 * Created by linjianxi on 2016/10/29.
 */
export const GET_HQPORD_INTO_LIST = 'GET_HQPORD_INTO_LIST'
export const GET_HQPORD_INTO_RECHANGE = 'GET_HQPORD_INTO_RECHANGE'
export const GET_HQPORD_DETAIL = 'GET_HQPORD_DETAIL'



// WEBPACK FOOTER //
// ./src/vuex/modules/hqpord_into/mutation-type.js